import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\DeleteStatusTaskController::__invoke
* @see app/Http/Controllers/Import/DeleteStatusTaskController.php
* @route '/api/import/{import}/task/{importTask}'
*/
const DeleteStatusTaskController = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteStatusTaskController.url(args, options),
    method: 'delete',
})

DeleteStatusTaskController.definition = {
    methods: ["delete"],
    url: '/api/import/{import}/task/{importTask}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Import\DeleteStatusTaskController::__invoke
* @see app/Http/Controllers/Import/DeleteStatusTaskController.php
* @route '/api/import/{import}/task/{importTask}'
*/
DeleteStatusTaskController.url = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            import: args[0],
            importTask: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        import: args.import,
        importTask: typeof args.importTask === 'object'
        ? args.importTask.id
        : args.importTask,
    }

    return DeleteStatusTaskController.definition.url
            .replace('{import}', parsedArgs.import.toString())
            .replace('{importTask}', parsedArgs.importTask.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\DeleteStatusTaskController::__invoke
* @see app/Http/Controllers/Import/DeleteStatusTaskController.php
* @route '/api/import/{import}/task/{importTask}'
*/
DeleteStatusTaskController.delete = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteStatusTaskController.url(args, options),
    method: 'delete',
})

export default DeleteStatusTaskController